<template>
  <div class="input-container">
    <label v-if="extraConfig.showTitle" class="input-title" :style="{width: extraConfig.titleWidth + 'px'}">{{ title }}</label>
    <el-input v-model="inputValue" class="input" placeholder="请输入"></el-input>
  </div>
</template>
<script>
export default {
  props: {
    defaultValue: String,
    title: String,
    config: String,
    extraConfig: {
      type: Object,
      default() {
        return {
          showTitle: true,
          titleWidth: 32
        }
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.config ?? this.defaultValue
      },
      set(newVal) {
        this.$emit('update:config', newVal)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.input-container {
  display: flex;
  align-items: center;
  .input-title {
    width: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    margin-right: 12px;
    font-weight: 400;
  }
  .input {
    flex: 1;
  }
  
}
</style>